import { render, staticRenderFns } from "./zhuanZhengHome.vue?vue&type=template&id=a1e57758&scoped=true&"
import script from "./zhuanZhengHome.vue?vue&type=script&lang=js&"
export * from "./zhuanZhengHome.vue?vue&type=script&lang=js&"
import style0 from "./zhuanZhengHome.vue?vue&type=style&index=0&id=a1e57758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e57758",
  null
  
)

export default component.exports